// src/router/RoutesFactory.tsx
import React, { useEffect, useState } from 'react';
import { countryConfig } from '../config/countryConfig';
import { REACT_APP_COUNTRY } from '../config';

export const RoutesFactory: React.FC = () => {
  const [RoutesComponent, setRoutesComponent] = useState<JSX.Element | null>(null);

  useEffect(() => {
    const loader = countryConfig[REACT_APP_COUNTRY as keyof typeof countryConfig];
    loader().then(module => {
      const Component = module.default;
      setRoutesComponent(<Component />);
    });
  }, []);

  if (!RoutesComponent) {
    return <div>Cargando aplicación...</div>;
  }
  return RoutesComponent;
};
